/**
 * Created by karora on 12/03/17.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Hub } from '../types/hub';
import { StandardResponse } from '../types/standard-response';
import { ApiService } from './api.service';

@Injectable()
export class HubSearchService {
  private static findHubsURL = '/api/private/hubs/find/';

  constructor(private api: ApiService) {}

  search(term: string): Observable<Hub[]> {
    return this.api.Get(HubSearchService.findHubsURL + `${term}`).pipe(
      map(function(response: StandardResponse) {
        if (response.status !== 'success') {
          throw Error(`Search failed :-(`);
        }
        return response.list as Hub[];
      })
    );
  }
}
